import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDrop = (props) => /* @__PURE__ */ _jsx("svg", {
	"aria-hidden": "true",
	"data-prefix": "fas",
	"data-icon": "tint",
	className: "svg-inline--fa fa-tint fa-w-11",
	role: "img",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 352 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
	})
});
export default SvgDrop;
